import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

import FolderSelector from 'modules/documents/components/Folders/FolderSelector'
import { useGetFolders } from 'modules/documents/hooks/useGetFolders'

interface Props {
  field: Field
}

export default function FolderSelect({ field }: Props) {
  const { loading, folders } = useGetFolders({ active: true })

  const folderId = field.value
  const initialFolder = folders.find((folder) => folder.id === String(folderId))

  if (loading)
    return (
      <Box alignItems="center">
        <Spinner />
      </Box>
    )

  return (
    <FolderSelector
      folders={folders}
      initialFolder={initialFolder}
      label={i18n.t('split_documents.form.select_label')}
      onChange={(value) => field.set(value)}
      noneOption={false}
    />
  )
}
